
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[eventSlug]/liveresults",
      function () {
        return require("private-next-pages/events/[eventSlug]/liveresults.tsx");
      }
    ]);
  